import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Tab extends PureComponent {
  render() {
    const { className, children } = this.props;
    const cls = classNames({
      "weui-tab": true,
      [className]: className
    });
    return (
      <div className={ cls }>
        { children }
      </div>
    );
  }
}
